import { Dialog } from '@material-ui/core';
import styled from 'styled-components';

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paperWidthSm {
    width: 576px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .success-close-icon {
    position: absolute;
    right: 15px;
    top: 15px;
  }

  .success-title {
    font-size: 18px;
    font-weight: Bold;
    color: #112138;
    margin: 10px 0 20px 0;
  }

  .success-content {
    text-align: center;
  }
  .success-actions {
    top: -10px;
    position: relative;
    padding: 5px;
    display: flex;
    flex-direction: column;
  }
  .success-actions > button {
    margin: 5px;
  }

  #secondary-button-style {
    margin: 20px 0;
    padding: 10px;
  }
  #primary-button-style {
    padding-left: 20px;
  }

  .ChevronRightIcon {
    margin-left: 10px;
    fill: white;
  }
`;
